import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { SchemasRoute } from '../../routing'

export  class SchemasPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <SchemasRoute />
          </Fragment>
        )
    }
}
